import type { CSSProperties, ReactNode } from "react";
import { C, font } from "../theme";

type ButtonVariant = "primary" | "outline" | "dark" | "ghost";

const variantStyle: Record<ButtonVariant, CSSProperties> = {
  primary: { background: C.lime, color: C.ink, border: "none" },
  outline: { background: "none", color: C.ink, border: `1px solid ${C.ink}` },
  dark: { background: C.ink, color: C.white, border: "none" },
  ghost: {
    background: "none",
    color: C.light,
    border: "none",
    textDecoration: "underline",
    padding: 0,
    borderRadius: 0,
  },
};

interface ButtonProps {
  children: ReactNode;
  variant?: ButtonVariant;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  form?: string;
  ariaLabel?: string;
  title?: string;
  style?: CSSProperties;
}

/** Botão padrão do Apogeu (fonte do tema, peso 700, cantos 8px). */
export function Button({ children, variant = "primary", onClick, disabled, type = "button", form, ariaLabel, title, style }: ButtonProps) {
  return (
    <button
      type={type}
      form={form}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
      style={{
        fontFamily: font,
        fontSize: 12,
        fontWeight: 700,
        borderRadius: 8,
        padding: "8px 14px",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.6 : 1,
        ...variantStyle[variant],
        ...style,
      }}
    >
      {children}
    </button>
  );
}
